import { useSearchParams } from 'react-router-dom';
import { styled } from 'styled-components';
import { ModalAction, useModal } from '../../../../context/ModalContext';
import { useState, useEffect } from 'react';
import { isFinalMonth, userGradeType } from '../../../../utils/auth';
import { useReportContext } from '../../../../context/DetailContext';
import { useUser } from '../../../../context/UserContext';

interface DetailOrNplTabProps {
  tab: string;
  setTab: (tab: string) => void;
  nplQuotaAccess: boolean;
}

const DetailOrNplTab = ({
  tab,
  setTab,
  nplQuotaAccess,
}: DetailOrNplTabProps) => {
  const [searchParams] = useSearchParams();
  const listType = searchParams.get('type');

  const { modalDispatch } = useModal();
  const { user } = useUser();
  const { regionAccess } = useReportContext();

  const handleClickNplTab = () => {
    if (nplQuotaAccess) {
      setTab('npl');
    } else {
      if (!regionAccess) {
        modalDispatch({
          type: 'USER_ALERT',
          payload: 'free',
        });
        return;
      }
      if (isFinalMonth(user?.plan_end)) {
        modalDispatch({
          type: 'USER_ALERT',
          payload: 'quotaDepletedExpiring',
        });
      } else {
        modalDispatch({
          type: 'USER_ALERT',
          payload: 'quotaDepleted',
        });
      }
    }
  };

  if (listType === 'b') {
    return (
      <TabBox>
        <TabButton
          active={tab === 'auction'}
          onClick={() => {
            setTab('auction');
          }}
        >
          물건 상세분석
        </TabButton>
        <TabButton active={tab === 'npl'} onClick={handleClickNplTab}>
          부실채권 투자 수익분석
        </TabButton>
      </TabBox>
    );
  } else {
    return '';
  }
};

const TabBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
`;
const TabButton = styled.span<{ active: boolean }>`
  flex: 1;
  padding: 10px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#222' : '#989BA2')};
  border-bottom: ${(props) => (props.active ? '2px solid #222' : 'none')};
  cursor: pointer;
`;

export default DetailOrNplTab;
